import * as constants from './constants';
import * as apiHelper from '../../../apiHelper'
import * as blobHelper from '../../../azureBlobHelper';
import { FilterAmenity_ExtendedStay, FilterAmenity_WeekendStay } from '../../search/constants';

const controller = "listing";

export function updateFormData(formData) {
  return {
    type: constants.UPDATE_FORM_DATA,
    data: formData
  }
}
export function reinitializeFormData() {
  return {
    type: constants.REINITIALIZE_FORM_DATA
  }
}

export function updateListingPhotos(photos) {
  return {
    type: constants.UPDATE_LISTING_PHOTOS,
    data: photos
  }
}

export function updateListingPhotosOrder(photos) {
  return {
    type: constants.UPDATE_LISTING_PHOTOS_ORDER,
    data: photos
  }
}

export function reinitializeCalendars() {
  return {
    type: constants.REINITIALIZE_CALENDARS
  }
}

export function reinitializePhotos() {
  return {
    type: constants.REINITIALIZE_PHOTOS
  }
}

export function updateCalendars(parsedIcalObject, calType) {
  return {
    type: constants.UPDATE_ICALS,
    data: [{ type: calType, data: parsedIcalObject }]
  }
}

export function setListing(listingData) {
  return {
    type: constants.SET_LISTING,
    data: listingData
  }
}

export function setListingBookings(bookings) {
  return {
    type: constants.SET_LISTING_BOOKINGS,
    data: bookings
  }
}

export function setListingCollection(listingArray) {
  return {
    type: constants.SET_LISTING_COLLECTION,
    data: listingArray
  }
}

function onUpdateListingDiscount(Listing) {
  if (Listing.listingData.discounts) {
    Listing.listingData.discounts.forEach(d => {
      if (d._id && d._id.indexOf(`d${d.name}i`) > -1) d._id = null;
    })
  }
  if (Listing.listingData.addOns) {
    Listing.listingData.addOns.forEach(a => {
      if (a._id && a._id.indexOf(`a${a.name}i`) > -1) a._id = null;
    })
  }
}

function onUpdateListingAmenities(Listing) {
  const { amenities } = Listing.listingData;
  const { extended_fee, weekend_fee } = Listing.listingData.pricing;

  if (!!extended_fee.from && !!extended_fee.to) {
    if (!amenities.includes(FilterAmenity_ExtendedStay)) {
      amenities.push(FilterAmenity_ExtendedStay);
    }
  }
  else if (amenities.includes(FilterAmenity_ExtendedStay)) {
    const index = amenities.indexOf(FilterAmenity_ExtendedStay);
    amenities.splice(index, 1);
  }

  if (!!weekend_fee.from && !!weekend_fee.to) {
    if (!amenities.includes(FilterAmenity_WeekendStay)) {
      amenities.push(FilterAmenity_WeekendStay);
    }
  }
  else if (amenities.includes(FilterAmenity_WeekendStay)) {
    const index = amenities.indexOf(FilterAmenity_WeekendStay);
    amenities.splice(index, 1);
  }
}

export function createListing() {
  return (dispatch, getState) => {
    let state = getState();
    let { Listing } = state;
    return apiHelper.apiPost(controller, Listing.formData)
      .then(response => response.json()
        .then(data => {
          dispatch(setListing(data.listing));
          return blobHelper.createBlobsFromArray(Listing.photos, data.listing._id);
        })
      );
  }
}

export function updateListing(photos) {
  return (dispatch, getState) => {
    let state = getState();

    const { Listing } = state;

    onUpdateListingDiscount(Listing);
    onUpdateListingAmenities(Listing);

    return apiHelper.apiPut(controller, Listing.listingData, state.Global.token, Listing.listingData._id)
      .then(response => response.json()
        .then(data => {
          dispatch(setListing(data));
          return photos ? blobHelper.createBlobsFromArray(Listing.photos, data._id) : true;
        })
      );
  }
}

export function publishListing(id, publish) {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPut(controller, { isActive: publish }, state.Global.token, id)
      .then(response => response.json().then(data => dispatch(setListing(data))));
  }
}

export function getListingsByOwner(ownerId) {
  let routes = ["owner", ownerId];
  return (dispatch) => {
    return apiHelper.apiGet(controller, null, null, routes)
      .then(response => response.json().then(array => {
        if (array && array.length > 0) {
          dispatch(setListingCollection(array));
        }
      }));
  }
}

export function getCalendar(url, callback) {
  return apiHelper.apiPost('calendar', { url: url })
    .then(response => response.text())
    .then(txt => callback(txt));
}

export function getBookings(id) {
  return (dispatch) => {
    return apiHelper.apiGet('bookings', null, id, 'listing')
      .then(response => response.json())
      .then(json => dispatch(setListingBookings(json.bookings.filter(b => b.bookingPaymentStatus !== 'Cancelled'))));
  }
}

export function sendNewListingEmail(user) {
  return (dispatch, getState) => {
    let state = getState();
    let { Listing } = state;
    return apiHelper.apiPut(controller, user, state.Global.token, Listing.listingData._id, "new")
      .then(response => response.json())
  }
}

// DISCOUNTS
export function getDiscounts(id) {
  return (dispatch, getState) => {
    let state = getState();
    const data = {
      listingId: id
    }
    // remove temporary discounts before fetching actual discounts
    return apiHelper.apiPost(controller, data, state.Global.token, "removeTemporaryDiscounts")
      .then(response => response.json())
      .then(json => {
        return apiHelper.apiGet(controller, state.Global.token, id, "discounts")
          .then(response => response.json())
          .then(json => {
            dispatch(setDiscounts(json));
          });
      });
  }
}

export function getDiscountById(listingId, code, startDate, endDate) {
  return (dispatch, getState) => {
    let state = getState();
    const data = {
      listingId: listingId,
      code: code,
      startDate: startDate,
      endDate: endDate
    }
    // remove temporary discounts before fetching actual discounts
    return apiHelper.apiPost(controller, data, state.Global.token, "getDiscountById")
      .then(response => response.json())
      .then(json => {
        if (json.length > 0) {
          dispatch(setSearchedDiscount(json[0]));
        } else {
          dispatch(setSearchedDiscount('test'));
        }
      });
  }
}

export function addDiscount(listingId, discount) {
  const data = {
    listingId: listingId,
    discount: discount
  }
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPost(controller, data, state.Global.token, "addDiscount")
      .then(response => response.json())
      .then(json => {
        dispatch(setDiscounts(json));
      });
  }
}

export function updateDiscount(listingId, discount) {
  const data = {
    listingId: listingId,
    discount: discount
  }
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPost(controller, data, state.Global.token, "updateDiscount")
      .then(response => response.json())
      .then(json => {
        if (json.error) { dispatch(pushError({ errType: "updateDiscount", error: json.error })) }
        dispatch(setDiscounts(json));
      })
  }
}

export function removeDiscount(listingId, discountId) {
  const data = {
    listingId: listingId,
    discountId: discountId
  }
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPost(controller, data, state.Global.token, "removeDiscount")
      .then(response => response.json())
      .then(json => {
        dispatch(setDiscounts(json));
      });
  }
}

export function removeTemporaryDiscounts(id) {
  const data = {
    listingId: id
  }
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPost(controller, data, state.Global.token, "removeTemporaryDiscounts")
      .then(response => response.json())
      .then(json => {
        dispatch(setDiscounts(json));
      });
  }
}

export function setDiscounts(data) {
  return {
    type: constants.SET_DISCOUNTS,
    data: data
  }
}

export function setSearchedDiscount(data) {
  return {
    type: constants.SET_SEARCHED_DISCOUNT,
    data: data
  }
}
// DISCOUNTS
export function removeAddOn(listingId, addOnId) {
  const data = {
    listingId: listingId,
    addOnId: addOnId
  }
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPost(controller, data, state.Global.token, "removeAddOn")
      .then(response => response.json())
  }
}
